import { Link } from "@mui/material";

export default function setWelcomeMessage(recruiter, setMessage, router) {
  const handleCreateFloat = () => {
    router.push("/floats/create");
  };

  if (recruiter.only_demo_float) {
    setMessage({
      primary: "Welcome to Floats!",
      secondary: (
        <span>
          Looks like you&apos;re new here. You&apos;re ready to{" "}
          <Link href="#" onClick={handleCreateFloat}>
            create your first Float
          </Link>
          . Update your <Link href="#settings">profile settings</Link> for a
          better experience.
        </span>
      ),
    });
  }
}
